(function () {
  'use strict';

  const content = document.querySelector('.article-template__content');
  const tpl = document.getElementById('blog-recommended-products-template');
  if (!content || !tpl || !tpl.content.children.length) return;

  const placeholder = '{{recommended-products}}';
  const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
  let node;

  while ((node = walker.nextNode())) {
    if (!node.textContent.includes(placeholder)) continue;

    const parent = node.parentNode;
    const fragment = tpl.content.cloneNode(true);

    if (parent.tagName === 'P' && parent.textContent.trim() === placeholder) {
      parent.replaceWith(fragment);
    } else {
      node.replaceWith(fragment);
    }
    return;
  }
})();
